/**
 * Stable CSS class names for E2E — Localization management.
 */
export const LOC = {
    page: 'localization-management-page',
    breadcrumbSection: 'localization-management-page__breadcrumb-section',
    loadingSection: 'localization-management-page__loading-section',

    toolbarGrid: 'localization-management-page__toolbar-grid',
    toolbarSpacer: 'localization-management-page__toolbar-spacer',
    toolbarFilterWrap: 'localization-management-page__toolbar-filter-wrap',
    inputButtonAddLocalization: 'localization-management-page-input--button-add-localization',
    inputButtonOpenFilterDrawer: 'localization-management-page-input--button-open-filter-drawer',
    gridWrap: 'localization-management-page__grid-wrap',

    emptyStateRoot: 'localization-management-page__empty-state',
    emptyStateMessageWrap: 'localization-management-page__empty-message-wrap',
    emptyStateImage: 'localization-management-page__empty-image',
    emptyStateHint: 'localization-management-page__empty-hint',
    wizardFormWrap: 'localization-management-page__wizard-form',
    wizardAppFieldWrap: 'localization-management-page__wizard-app-field',
    inputSelectWizardApp: 'localization-management-page-input--select-wizard-app',
    wizardCultureFieldWrap: 'localization-management-page__wizard-culture-field',
    inputSelectWizardCulture: 'localization-management-page-input--select-wizard-culture',
    wizardKeywordFieldWrap: 'localization-management-page__wizard-keyword-field',
    inputTextWizardKeyword: 'localization-management-page-input--text-wizard-keyword',
    wizardFilterButtonWrap: 'localization-management-page__wizard-filter-button-wrap',
    inputButtonWizardFilter: 'localization-management-page-input--button-wizard-filter',

    datagridActionsCell: 'localization-management-datagrid-actions-cell',
    inputIconRowActionsMenu: 'localization-management-datagrid-input--icon-row-actions-menu',
    rowActionsMenuPaper: 'localization-management-datagrid__row-actions-menu',
    inputMenuItemRowEdit: 'localization-management-datagrid-input--menu-item-row-edit',
    inputMenuItemRowDelete: 'localization-management-datagrid-input--menu-item-row-delete',

    filterDrawerPaper: 'localization-management-filter-drawer',
    filterDrawerBody: 'localization-management-filter-drawer__body',
    filterDrawerHeaderRoot: 'localization-management-filter-drawer__header',
    filterDrawerHeaderTitle: 'localization-management-filter-drawer__header-title',
    inputIconFilterDrawerClose: 'localization-management-filter-drawer-input--icon-close',
    filterDrawerAppField: 'localization-management-filter-drawer__app-field',
    inputSelectFilterApp: 'localization-management-filter-drawer-input--select-app',
    filterDrawerCultureField: 'localization-management-filter-drawer__culture-field',
    inputSelectFilterCulture: 'localization-management-filter-drawer-input--select-culture',
    filterDrawerKeywordField: 'localization-management-filter-drawer__keyword-field',
    inputTextFilterKeyword: 'localization-management-filter-drawer-input--text-keyword',
    filterDrawerFooter: 'localization-management-filter-drawer__footer',
    inputButtonFilterApply: 'localization-management-filter-drawer-input--button-filter',

    editDrawerPaper: 'localization-management-edit-drawer',
    editDrawerBody: 'localization-management-edit-drawer__body',
    editDrawerHeaderRoot: 'localization-management-edit-drawer__header',
    editDrawerHeaderTitle: 'localization-management-edit-drawer__header-title',
    inputIconEditDrawerClose: 'localization-management-edit-drawer-input--icon-close',
    editDrawerAppField: 'localization-management-edit-drawer__app-field',
    inputTextEditAppReadonly: 'localization-management-edit-drawer-input--text-app-readonly',
    editDrawerKeywordsField: 'localization-management-edit-drawer__keywords-field',
    inputTextEditKeywordsReadonly: 'localization-management-edit-drawer-input--text-keywords-readonly',
    editDrawerValueField: 'localization-management-edit-drawer__value-field',
    inputTextEditKeywordValue: 'localization-management-edit-drawer-input--text-keyword-value',
    editDrawerFooter: 'localization-management-edit-drawer__footer',
    inputButtonEditUpdate: 'localization-management-edit-drawer-input--button-update',

    addDrawerPaper: 'localization-management-add-drawer',
    addDrawerRoot: 'localization-management-add-drawer__root',
    addDrawerTitleRow: 'localization-management-add-drawer__title-row',
    addDrawerTitle: 'localization-management-add-drawer__title',
    inputIconAddDrawerClose: 'localization-management-add-drawer-input--icon-close',
    addDrawerAppField: 'localization-management-add-drawer__app-field',
    inputSelectAddApp: 'localization-management-add-drawer-input--select-app',
    addDrawerCultureField: 'localization-management-add-drawer__culture-field',
    inputSelectAddCulture: 'localization-management-add-drawer-input--select-culture',
    addDrawerKeywordField: 'localization-management-add-drawer__keyword-field',
    inputTextAddKeyword: 'localization-management-add-drawer-input--text-keyword',
    addDrawerKeywordsField: 'localization-management-add-drawer__keywords-field',
    inputTextAddKeywords: 'localization-management-add-drawer-input--text-keywords',
    addDrawerFooter: 'localization-management-add-drawer__footer',
    inputButtonAddSave: 'localization-management-add-drawer-input--button-save',

    confirmDialogPaper: 'localization-management-confirm-dialog',
    confirmDialogProgressWrap: 'localization-management-confirm-dialog__progress-wrap',
    confirmDialogTitle: 'localization-management-confirm-dialog__title',
    confirmDialogContent: 'localization-management-confirm-dialog__content',
    confirmDialogActions: 'localization-management-confirm-dialog__actions',
    inputButtonConfirmReject: 'localization-management-confirm-dialog-input--button-reject',
    inputButtonConfirmAccept: 'localization-management-confirm-dialog-input--button-accept',
} as const;

/** Pass to SCUIConfirmDialog `e2eClassNames` */
export const locConfirmDialogE2e = {
    dialogPaper: LOC.confirmDialogPaper,
    progressWrap: LOC.confirmDialogProgressWrap,
    dialogTitle: LOC.confirmDialogTitle,
    dialogContent: LOC.confirmDialogContent,
    dialogActions: LOC.confirmDialogActions,
    rejectButton: LOC.inputButtonConfirmReject,
    acceptButton: LOC.inputButtonConfirmAccept,
} as const;

export const locCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
